import { ReactKeycloakProvider } from '@react-keycloak/web'
import React from 'react'
import { initOptions, keycloak } from './keycloak'
import { LoadUserWrap } from './LoadUserWrap'

const KeycloakUserProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
      <LoadUserWrap>{children}</LoadUserWrap>
    </ReactKeycloakProvider>
  )
}

export default KeycloakUserProvider
